module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboarding"
  }, [(_vm.modal.isOpen) ? _c('onboarding-modal', {
    attrs: {
      "has-mask": _vm.modal.hasMask,
      "can-click-mask": _vm.modal.canClickMask,
      "has-x": _vm.modal.hasX
    },
    on: {
      "toggle": _vm.toggleModal
    }
  }, [_c('article', {
    staticClass: "onboarding-body"
  }, [_c('section', [_c('div', {
    staticClass: "modal-top"
  }, [_c('img', {
    staticClass: "first-step",
    attrs: {
      "src": require("../../../assets/onboarding-step1.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-bottom"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("ui.onboarding.step1.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.onboarding.step1.subtitle")))])]), _vm._v(" "), _c('footer', {
    staticClass: "onboarding-footer"
  }, [_c('div', {
    staticClass: "forward-actions"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLastStep),
      expression: "!isLastStep"
    }],
    staticClass: "primary next",
    attrs: {
      "disabled": _vm.isLastStep
    },
    on: {
      "click": function($event) {
        return _vm.skip(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.next")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLastStep),
      expression: "isLastStep"
    }],
    staticClass: "accent save",
    attrs: {
      "disabled": !_vm.isLastStep
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.start")))])]), _vm._v(" "), (_vm.hasDots) ? _c('div', {
    staticClass: "step-dots"
  }, _vm._l((_vm.max), function(n) {
    return _c('div', {
      staticClass: "step-dot",
      class: {
        active: n == _vm.step
      },
      on: {
        "click": function($event) {
          return _vm.goToStep(n)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "back-actions"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLastStep),
      expression: "!isLastStep"
    }],
    staticClass: "secondary skip",
    attrs: {
      "disabled": _vm.isLastStep
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.skip")))])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "modal-top"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/onboarding-step2.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-bottom"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("ui.onboarding.step2.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.onboarding.step2.subtitle")) + " ")])]), _vm._v(" "), _c('footer', {
    staticClass: "onboarding-footer"
  }, [_c('div', {
    staticClass: "forward-actions"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLastStep),
      expression: "!isLastStep"
    }],
    staticClass: "primary next",
    attrs: {
      "disabled": _vm.isLastStep
    },
    on: {
      "click": function($event) {
        return _vm.skip(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.next")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLastStep),
      expression: "isLastStep"
    }],
    staticClass: "accent save",
    attrs: {
      "disabled": !_vm.isLastStep
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.start")))])]), _vm._v(" "), (_vm.hasDots) ? _c('div', {
    staticClass: "step-dots"
  }, _vm._l((_vm.max), function(n) {
    return _c('div', {
      staticClass: "step-dot",
      class: {
        active: n == _vm.step
      },
      on: {
        "click": function($event) {
          return _vm.goToStep(n)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "back-actions"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLastStep),
      expression: "!isLastStep"
    }],
    staticClass: "secondary skip",
    attrs: {
      "disabled": _vm.isLastStep
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.skip")))])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "modal-top"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/onboarding-step3.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-bottom"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("ui.onboarding.step3.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.onboarding.step3.subtitle")))])]), _vm._v(" "), _c('footer', {
    staticClass: "onboarding-footer"
  }, [_c('div', {
    staticClass: "forward-actions"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLastStep),
      expression: "!isLastStep"
    }],
    staticClass: "primary next",
    attrs: {
      "disabled": _vm.isLastStep
    },
    on: {
      "click": function($event) {
        return _vm.skip(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.next")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLastStep),
      expression: "isLastStep"
    }],
    staticClass: "accent save",
    attrs: {
      "disabled": !_vm.isLastStep
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.start")))])]), _vm._v(" "), (_vm.hasDots) ? _c('div', {
    staticClass: "step-dots"
  }, _vm._l((_vm.max), function(n) {
    return _c('div', {
      staticClass: "step-dot",
      class: {
        active: n == _vm.step
      },
      on: {
        "click": function($event) {
          return _vm.goToStep(n)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "back-actions"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLastStep),
      expression: "!isLastStep"
    }],
    staticClass: "secondary skip",
    attrs: {
      "disabled": _vm.isLastStep
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.skip")))])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7082604","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/OnBoarding.vue
// module id = 1980
// module chunks = 0